import HomestayList from './HomestayList';

export default HomestayList;
